/**
 * @generated SignedSource<<832853b004f3f36219f1609267f48098>>
 * @relayHash e7dbf800b0d4edfbfe9ec8cdcff81b5d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2f184179b031fa92b41f52f28374cc1643bac2ef4db649db9fa7c97be2597cdd

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SearchCombinationType = "AND" | "OR" | "%future added value";
export type SearchConfluenceDocumentStatus = "ARCHIVED" | "CURRENT" | "DRAFT" | "%future added value";
export type SearchConfluenceRangeField = "CREATED" | "LASTMODIFIED" | "%future added value";
export type SearchContainerStatus = "ARCHIVED" | "CURRENT" | "%future added value";
export type SearchIssueStatusCategory = "DONE" | "INDETERMINATE" | "NEW" | "OPEN" | "UNDEFINED" | "%future added value";
export type SearchLinkedEntityGranularity = "ALL_MATCHING_MESSAGES" | "DEFAULT" | "FULL_THREAD" | "%future added value";
export type SearchParticipantType = "CONTRIBUTOR" | "MENTIONS" | "PRESENCE" | "%future added value";
export type SearchProjectType = "business" | "customer_service" | "product_discovery" | "service_desk" | "software" | "%future added value";
export type SearchSortOrder = "ASC" | "DESC" | "%future added value";
export type SearchThirdPartyRangeField = "CREATED" | "LASTMODIFIED" | "%future added value";
export type SearchAssetsFilter = {
  objectSchemaFilter?: SearchAssetsObjectSchemaFilter | null | undefined;
  objectTypeFilter?: SearchAssetsObjectTypeFilter | null | undefined;
};
export type SearchAssetsObjectSchemaFilter = {
  schemaARIs?: ReadonlyArray<string> | null | undefined;
};
export type SearchAssetsObjectTypeFilter = {
  typeARIs?: ReadonlyArray<string> | null | undefined;
};
export type SearchCommonFilter = {
  contributorsFilter?: ReadonlyArray<string> | null | undefined;
  participants?: SearchParticipants | null | undefined;
  range?: SearchCommonRangeFilter | null | undefined;
};
export type SearchParticipants = {
  combination: SearchCombinationType;
  items: ReadonlyArray<SearchParticipant>;
};
export type SearchParticipant = {
  combination: SearchCombinationType;
  type: SearchParticipantType;
  users: ReadonlyArray<string>;
};
export type SearchCommonRangeFilter = {
  created?: SearchCommonRangeFilterFields | null | undefined;
  lastModified?: SearchCommonRangeFilterFields | null | undefined;
};
export type SearchCommonRangeFilterFields = {
  gt?: string | null | undefined;
  lt?: string | null | undefined;
};
export type SearchCompassFilter = {
  componentFilter?: SearchCompassComponentFilter | null | undefined;
};
export type SearchCompassComponentFilter = {
  componentStates: ReadonlyArray<string>;
};
export type SearchConfluenceFilter = {
  ancestorIdsFilter?: ReadonlyArray<string> | null | undefined;
  containerARIs?: ReadonlyArray<string> | null | undefined;
  containerStatus?: ReadonlyArray<SearchContainerStatus | null | undefined> | null | undefined;
  contentStatuses?: ReadonlyArray<SearchConfluenceDocumentStatus> | null | undefined;
  contributorsFilter?: ReadonlyArray<string> | null | undefined;
  creatorsFilter?: ReadonlyArray<string> | null | undefined;
  isVerified?: boolean | null | undefined;
  labelsFilter?: ReadonlyArray<string> | null | undefined;
  mentions?: ReadonlyArray<string> | null | undefined;
  owners?: ReadonlyArray<string> | null | undefined;
  pageStatus?: ReadonlyArray<string> | null | undefined;
  range?: ReadonlyArray<SearchConfluenceRangeFilter | null | undefined> | null | undefined;
  spacesFilter?: ReadonlyArray<string> | null | undefined;
  titleMatchOnly?: boolean | null | undefined;
};
export type SearchConfluenceRangeFilter = {
  field: SearchConfluenceRangeField;
  gt?: string | null | undefined;
  lt?: string | null | undefined;
};
export type SearchExperimentLayer = {
  definitions?: ReadonlyArray<SearchLayerDefinition | null | undefined> | null | undefined;
  layerId?: string | null | undefined;
  name?: string | null | undefined;
  shadowId?: string | null | undefined;
};
export type SearchLayerDefinition = {
  abTestId?: string | null | undefined;
  connectorSources?: ReadonlyArray<string | null | undefined> | null | undefined;
  entity?: string | null | undefined;
  integrationARI?: string | null | undefined;
  layerId?: string | null | undefined;
  providerId?: string | null | undefined;
  shadowId?: string | null | undefined;
  subEntity?: string | null | undefined;
};
export type SearchJiraFilter = {
  boardFilter?: SearchBoardFilter | null | undefined;
  issueFilter?: SearchJiraIssueFilter | null | undefined;
  projectFilter?: SearchJiraProjectFilter | null | undefined;
};
export type SearchBoardFilter = {
  negateProjectFilter?: boolean | null | undefined;
  projectARI?: string | null | undefined;
  userARI?: string | null | undefined;
};
export type SearchJiraIssueFilter = {
  assigneeARIs?: ReadonlyArray<string> | null | undefined;
  commenterARIs?: ReadonlyArray<string> | null | undefined;
  issueLabels?: ReadonlyArray<string> | null | undefined;
  issueTypeIDs?: ReadonlyArray<string> | null | undefined;
  issueTypes?: ReadonlyArray<string> | null | undefined;
  projectARIs?: ReadonlyArray<string> | null | undefined;
  reporterARIs?: ReadonlyArray<string> | null | undefined;
  statusCategories?: ReadonlyArray<SearchIssueStatusCategory> | null | undefined;
  watcherARIs?: ReadonlyArray<string> | null | undefined;
};
export type SearchJiraProjectFilter = {
  projectType?: SearchProjectType | null | undefined;
  projectTypes?: ReadonlyArray<SearchProjectType> | null | undefined;
};
export type SearchMercuryFilter = {
  ancestorIds?: ReadonlyArray<string> | null | undefined;
  focusAreaTypeIds?: ReadonlyArray<string> | null | undefined;
  owners?: ReadonlyArray<string> | null | undefined;
};
export type SearchSortInput = {
  field: string;
  key?: string | null | undefined;
  order: SearchSortOrder;
};
export type SearchTalentFilter = {
  employmentTypes?: ReadonlyArray<string> | null | undefined;
  focusAreas?: ReadonlyArray<string> | null | undefined;
  jobFamilies?: ReadonlyArray<string> | null | undefined;
  owners?: ReadonlyArray<string> | null | undefined;
  statuses?: ReadonlyArray<string> | null | undefined;
  teams?: ReadonlyArray<string> | null | undefined;
};
export type SearchThirdPartyFilter = {
  additionalTexts?: ReadonlyArray<string> | null | undefined;
  ancestorAris?: ReadonlyArray<string> | null | undefined;
  assignees?: ReadonlyArray<string> | null | undefined;
  containerAris?: ReadonlyArray<string> | null | undefined;
  containerNames?: ReadonlyArray<string> | null | undefined;
  containerTypes?: ReadonlyArray<string> | null | undefined;
  createdBy?: ReadonlyArray<string> | null | undefined;
  excludeSubtypes?: ReadonlyArray<string> | null | undefined;
  integrations?: ReadonlyArray<string> | null | undefined;
  labels?: ReadonlyArray<string> | null | undefined;
  lastUpdatedBy?: ReadonlyArray<string> | null | undefined;
  range?: ReadonlyArray<SearchThirdPartyRangeFilter | null | undefined> | null | undefined;
  subtypes?: ReadonlyArray<string | null | undefined> | null | undefined;
  teamsFilters?: SearchTeamsFilters | null | undefined;
  thirdPartyProducts?: ReadonlyArray<SearchThirdPartyProduct> | null | undefined;
  thirdPartyTypes?: ReadonlyArray<string> | null | undefined;
  titleMatchOnly?: boolean | null | undefined;
};
export type SearchThirdPartyRangeFilter = {
  field: SearchThirdPartyRangeField;
  gt?: string | null | undefined;
  lt?: string | null | undefined;
};
export type SearchTeamsFilters = {
  attachmentFileTypes?: ReadonlyArray<string> | null | undefined;
  hasAttachment?: boolean | null | undefined;
  hasLink?: boolean | null | undefined;
};
export type SearchThirdPartyProduct = {
  connectionIds?: ReadonlyArray<string> | null | undefined;
  connectorSources?: ReadonlyArray<string> | null | undefined;
  containerTypes?: ReadonlyArray<string> | null | undefined;
  datasourceId?: string | null | undefined;
  entities?: ReadonlyArray<string> | null | undefined;
  integrationId?: string | null | undefined;
  linkedEntityGranularity?: SearchLinkedEntityGranularity | null | undefined;
  product?: string | null | undefined;
  providerId?: string | null | undefined;
  subtypes?: ReadonlyArray<string> | null | undefined;
};
export type SearchResultsPaginationQuery$variables = {
  after?: string | null | undefined;
  assetsFilters?: SearchAssetsFilter | null | undefined;
  cloudIdARI: string;
  commonFilters?: SearchCommonFilter | null | undefined;
  compassFilters?: SearchCompassFilter | null | undefined;
  confluenceFilters?: SearchConfluenceFilter | null | undefined;
  disableQueryReplacement?: boolean | null | undefined;
  enableHighlighting?: boolean | null | undefined;
  entities: ReadonlyArray<string>;
  experience: string;
  experimentId?: string | null | undefined;
  experimentLayers?: ReadonlyArray<SearchExperimentLayer | null | undefined> | null | undefined;
  fanoutExperimentCohort?: string | null | undefined;
  includeAssets: boolean;
  includeAssigneeField?: boolean | null | undefined;
  includeAutoAppliedFilters?: boolean | null | undefined;
  includeIconUrl?: boolean | null | undefined;
  includeNavBoostScore?: boolean | null | undefined;
  includePassionfruitAsk?: boolean | null | undefined;
  includePositions?: boolean | null | undefined;
  includeThirdPartyId?: boolean | null | undefined;
  jiraFilters?: SearchJiraFilter | null | undefined;
  limit?: number | null | undefined;
  mercuryFilters?: SearchMercuryFilter | null | undefined;
  query?: string | null | undefined;
  queryVersion?: number | null | undefined;
  searchSessionId?: string | null | undefined;
  sessionId?: string | null | undefined;
  shadowExperimentId?: string | null | undefined;
  sort?: ReadonlyArray<SearchSortInput | null | undefined> | null | undefined;
  sourceProduct?: string | null | undefined;
  talentFilters?: SearchTalentFilter | null | undefined;
  tenantId: string;
  thirdPartyFilters?: SearchThirdPartyFilter | null | undefined;
};
export type SearchResultsPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"searchResults_AtlassianSearchPage">;
};
export type SearchResultsPaginationQuery = {
  response: SearchResultsPaginationQuery$data;
  variables: SearchResultsPaginationQuery$variables;
};
({
  "includeAssets": includeAssets_provider,
  "__relay_internal__pv__isassetsenabledrelayprovider": includeAssets_provider,
  "__relay_internal__pv__iscustomerorgownersenabledrelayprovider": isCustomerOrgOwnersEnabled_provider,
  "__relay_internal__pv__isdealownersenabledrelayprovider": isDealOwnersEnabled_provider,
  "__relay_internal__pv__jsmdcenabledrelayprovider": isJsmDcEnabled_provider
} as {
  readonly __relay_internal__pv__isassetsenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__iscustomerorgownersenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__isdealownersenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jsmdcenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly includeAssets: {
    readonly get: () => boolean;
  };
});

import includeAssets_provider from './../is-assets-enabled.relayprovider';
import isCustomerOrgOwnersEnabled_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-customer-org/is-customer-org-owners-enabled.relayprovider';
import isDealOwnersEnabled_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-deal/is-deal-owners-enabled.relayprovider';
import isJsmDcEnabled_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-jira-dc/jsm-dc-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assetsFilters"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudIdARI"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commonFilters"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "compassFilters"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "confluenceFilters"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "disableQueryReplacement"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "enableHighlighting"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entities"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experience"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experimentId"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experimentLayers"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fanoutExperimentCohort"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeAssets"
},
v14 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAssigneeField"
},
v15 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAutoAppliedFilters"
},
v16 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeIconUrl"
},
v17 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeNavBoostScore"
},
v18 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includePassionfruitAsk"
},
v19 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includePositions"
},
v20 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeThirdPartyId"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraFilters"
},
v22 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v23 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mercuryFilters"
},
v24 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v25 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryVersion"
},
v26 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchSessionId"
},
v27 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sessionId"
},
v28 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shadowExperimentId"
},
v29 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v30 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceProduct"
},
v31 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "talentFilters"
},
v32 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tenantId"
},
v33 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "thirdPartyFilters"
},
v34 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "queryVersion",
        "variableName": "queryVersion"
      },
      {
        "kind": "Variable",
        "name": "searchSessionId",
        "variableName": "searchSessionId"
      },
      {
        "kind": "Variable",
        "name": "sessionId",
        "variableName": "sessionId"
      },
      {
        "kind": "Variable",
        "name": "sourceProduct",
        "variableName": "sourceProduct"
      }
    ],
    "kind": "ObjectValue",
    "name": "analytics"
  },
  {
    "kind": "Variable",
    "name": "disableQueryReplacement",
    "variableName": "disableQueryReplacement"
  },
  {
    "kind": "Variable",
    "name": "enableHighlighting",
    "variableName": "enableHighlighting"
  },
  {
    "kind": "Variable",
    "name": "experience",
    "variableName": "experience"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "experimentId",
        "variableName": "experimentId"
      },
      {
        "kind": "Variable",
        "name": "experimentLayers",
        "variableName": "experimentLayers"
      },
      {
        "kind": "Variable",
        "name": "shadowExperimentId",
        "variableName": "shadowExperimentId"
      }
    ],
    "kind": "ObjectValue",
    "name": "experimentContext"
  },
  {
    "kind": "Variable",
    "name": "fanoutExperimentCohort",
    "variableName": "fanoutExperimentCohort"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "assetsFilters",
        "variableName": "assetsFilters"
      },
      {
        "kind": "Variable",
        "name": "commonFilters",
        "variableName": "commonFilters"
      },
      {
        "kind": "Variable",
        "name": "compassFilters",
        "variableName": "compassFilters"
      },
      {
        "kind": "Variable",
        "name": "confluenceFilters",
        "variableName": "confluenceFilters"
      },
      {
        "kind": "Variable",
        "name": "entities",
        "variableName": "entities"
      },
      {
        "kind": "Variable",
        "name": "jiraFilters",
        "variableName": "jiraFilters"
      },
      {
        "items": [
          {
            "kind": "Variable",
            "name": "locations.0",
            "variableName": "cloudIdARI"
          }
        ],
        "kind": "ListValue",
        "name": "locations"
      },
      {
        "kind": "Variable",
        "name": "mercuryFilters",
        "variableName": "mercuryFilters"
      },
      {
        "kind": "Variable",
        "name": "talentFilters",
        "variableName": "talentFilters"
      },
      {
        "kind": "Variable",
        "name": "thirdPartyFilters",
        "variableName": "thirdPartyFilters"
      }
    ],
    "kind": "ObjectValue",
    "name": "filters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "limit"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  },
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "sort"
  }
],
v35 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v36 = {
  "kind": "ScalarField",
  "name": "id"
},
v37 = {
  "kind": "ScalarField",
  "name": "description"
},
v38 = {
  "kind": "ScalarField",
  "name": "connectorType"
},
v39 = {
  "kind": "ScalarField",
  "name": "title"
},
v40 = {
  "kind": "ScalarField",
  "name": "url"
},
v41 = {
  "kind": "ScalarField",
  "name": "type"
},
v42 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
},
v43 = {
  "kind": "ScalarField",
  "name": "subtype"
},
v44 = {
  "kind": "ScalarField",
  "name": "integrationId"
},
v45 = {
  "kind": "ScalarField",
  "name": "providerId"
},
v46 = {
  "kind": "ScalarField",
  "name": "value"
},
v47 = {
  "kind": "ScalarField",
  "name": "label"
},
v48 = [
  (v47/*: any*/)
],
v49 = {
  "kind": "ScalarField",
  "name": "key"
},
v50 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v51 = [
  (v50/*: any*/)
],
v52 = {
  "condition": "includeIconUrl",
  "kind": "Condition",
  "passingValue": true,
  "selections": (v51/*: any*/)
},
v53 = {
  "kind": "ScalarField",
  "name": "name"
},
v54 = [
  (v53/*: any*/)
],
v55 = {
  "kind": "ScalarField",
  "name": "lastModified"
},
v56 = {
  "kind": "ScalarField",
  "name": "total"
},
v57 = {
  "kind": "InlineFragment",
  "selections": [
    (v36/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v58 = {
  "kind": "ScalarField",
  "name": "picture"
},
v59 = {
  "kind": "ScalarField",
  "name": "email"
},
v60 = [
  {
    "kind": "ScalarField",
    "name": "jobTitle"
  }
],
v61 = {
  "args": [
    {
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "tenantId"
    }
  ],
  "concreteType": "SocialSignalSearch",
  "kind": "LinkedField",
  "name": "socialSignal",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "signal"
    },
    {
      "kind": "ScalarField",
      "name": "timestamp"
    },
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v35/*: any*/),
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        (v53/*: any*/),
        (v58/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v59/*: any*/),
            {
              "concreteType": "AtlassianAccountUserExtendedProfile",
              "kind": "LinkedField",
              "name": "extendedProfile",
              "plural": false,
              "selections": (v60/*: any*/)
            }
          ],
          "type": "AtlassianAccountUser"
        },
        (v36/*: any*/)
      ]
    }
  ]
},
v62 = {
  "kind": "LinkedField",
  "name": "container",
  "plural": false,
  "selections": [
    (v35/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v54/*: any*/),
      "type": "ExternalRepository"
    },
    (v57/*: any*/)
  ]
},
v63 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v64 = {
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v35/*: any*/),
    (v53/*: any*/),
    (v58/*: any*/),
    (v36/*: any*/)
  ]
},
v65 = {
  "kind": "LinkedField",
  "name": "container",
  "plural": false,
  "selections": [
    (v35/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v63/*: any*/),
        (v40/*: any*/)
      ],
      "type": "ExternalSpace"
    },
    (v57/*: any*/)
  ]
},
v66 = {
  "kind": "ScalarField",
  "name": "externalId"
},
v67 = {
  "kind": "ScalarField",
  "name": "nickname"
},
v68 = {
  "concreteType": "ThirdPartyUserExtendedProfile",
  "kind": "LinkedField",
  "name": "extendedProfile",
  "plural": false,
  "selections": (v60/*: any*/)
},
v69 = [
  (v66/*: any*/),
  (v53/*: any*/),
  (v67/*: any*/),
  (v59/*: any*/),
  (v58/*: any*/),
  (v68/*: any*/),
  (v36/*: any*/)
],
v70 = {
  "concreteType": "ExternalAssociationConnection",
  "kind": "LinkedField",
  "name": "associatedWith",
  "plural": false,
  "selections": [
    {
      "concreteType": "ExternalAssociationEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "ExternalAssociation",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "entity",
              "plural": false,
              "selections": [
                (v35/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v69/*: any*/),
                  "type": "ThirdPartyUser"
                },
                (v57/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": "channelId",
                      "kind": "ScalarField",
                      "name": "externalId"
                    },
                    (v63/*: any*/)
                  ],
                  "type": "ExternalConversation"
                }
              ]
            },
            (v36/*: any*/)
          ]
        }
      ]
    }
  ]
},
v71 = {
  "kind": "ScalarField",
  "name": "thumbnailUrl"
},
v72 = [
  (v36/*: any*/),
  (v53/*: any*/),
  (v59/*: any*/),
  (v58/*: any*/),
  (v66/*: any*/),
  (v68/*: any*/)
],
v73 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": [
    {
      "concreteType": "ThirdPartyUser",
      "kind": "LinkedField",
      "name": "thirdPartyUser",
      "plural": false,
      "selections": (v72/*: any*/)
    }
  ]
},
v74 = [
  (v36/*: any*/),
  (v53/*: any*/)
],
v75 = {
  "concreteType": "ThirdPartyUser",
  "kind": "LinkedField",
  "name": "thirdPartyUser",
  "plural": false,
  "selections": (v74/*: any*/)
},
v76 = [
  (v75/*: any*/)
],
v77 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "members",
  "plural": true,
  "selections": (v76/*: any*/)
},
v78 = {
  "kind": "ScalarField",
  "name": "memberCount"
},
v79 = [
  (v53/*: any*/),
  (v36/*: any*/)
],
v80 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "owners",
  "plural": true,
  "selections": [
    {
      "concreteType": "ThirdPartyUser",
      "kind": "LinkedField",
      "name": "thirdPartyUser",
      "plural": false,
      "selections": (v79/*: any*/)
    }
  ]
},
v81 = [
  (v80/*: any*/)
],
v82 = {
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": [
    (v35/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v36/*: any*/),
        (v63/*: any*/)
      ],
      "type": "ExternalCustomerOrg"
    },
    (v57/*: any*/)
  ]
},
v83 = [
  {
    "kind": "ScalarField",
    "name": "lastActivityAt"
  },
  {
    "kind": "ScalarField",
    "name": "event"
  }
],
v84 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "assignee",
  "plural": false,
  "selections": (v76/*: any*/)
},
v85 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v76/*: any*/)
},
v86 = {
  "kind": "ScalarField",
  "name": "dueDate"
},
v87 = {
  "kind": "ScalarField",
  "name": "status"
},
v88 = {
  "condition": "__relay_internal__pv__jsmdcenabledrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "LinkedField",
      "name": "container",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v43/*: any*/)
          ],
          "type": "ExternalSpace"
        }
      ]
    }
  ]
},
v89 = [
  (v35/*: any*/),
  (v53/*: any*/),
  (v36/*: any*/)
],
v90 = {
  "kind": "ScalarField",
  "name": "workspaceName"
},
v91 = {
  "kind": "ScalarField",
  "name": "excerpt"
},
v92 = {
  "kind": "ScalarField",
  "name": "eventEndTime"
},
v93 = {
  "kind": "ScalarField",
  "name": "eventStartTime"
},
v94 = {
  "kind": "ScalarField",
  "name": "videoMeetingUrl"
},
v95 = {
  "concreteType": "ThirdPartyUser",
  "kind": "LinkedField",
  "name": "initialContributors",
  "plural": true,
  "selections": (v72/*: any*/)
},
v96 = {
  "concreteType": "ThirdPartyUser",
  "kind": "LinkedField",
  "name": "allContributors",
  "plural": true,
  "selections": (v69/*: any*/)
},
v97 = {
  "concreteType": "ThirdPartyUser",
  "kind": "LinkedField",
  "name": "allContributors",
  "plural": true,
  "selections": [
    (v53/*: any*/),
    (v67/*: any*/),
    (v59/*: any*/),
    (v58/*: any*/),
    (v66/*: any*/),
    (v68/*: any*/),
    (v36/*: any*/)
  ]
},
v98 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v99 = [
  (v42/*: any*/),
  (v50/*: any*/)
],
v100 = [
  {
    "kind": "ScalarField",
    "name": "targetDate"
  },
  {
    "kind": "ScalarField",
    "name": "targetDateType"
  }
],
v101 = [
  (v42/*: any*/)
],
v102 = {
  "concreteType": "AssetsLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "web"
    }
  ]
},
v103 = {
  "concreteType": "AssetsSchema",
  "kind": "LinkedField",
  "name": "objectSchemaEntity",
  "plural": false,
  "selections": (v79/*: any*/)
},
v104 = [
  {
    "kind": "ScalarField",
    "name": "url48"
  }
],
v105 = [
  (v49/*: any*/),
  (v36/*: any*/)
],
v106 = {
  "kind": "ScalarField",
  "name": "combination"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/)
    ],
    "kind": "Fragment",
    "name": "SearchResultsPaginationQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "includeAssigneeField",
            "variableName": "includeAssigneeField"
          },
          {
            "kind": "Variable",
            "name": "includeAutoAppliedFilters",
            "variableName": "includeAutoAppliedFilters"
          },
          {
            "kind": "Variable",
            "name": "includeIconUrl",
            "variableName": "includeIconUrl"
          },
          {
            "kind": "Variable",
            "name": "includeNavBoostScore",
            "variableName": "includeNavBoostScore"
          },
          {
            "kind": "Variable",
            "name": "includePassionfruitAsk",
            "variableName": "includePassionfruitAsk"
          },
          {
            "kind": "Variable",
            "name": "includePositions",
            "variableName": "includePositions"
          },
          {
            "kind": "Variable",
            "name": "includeThirdPartyId",
            "variableName": "includeThirdPartyId"
          }
        ],
        "kind": "FragmentSpread",
        "name": "searchResults_AtlassianSearchPage"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__isassetsenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__isdealownersenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jsmdcenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "SearchResultsPaginationQuery",
    "selections": [
      {
        "concreteType": "SearchQueryAPI",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": [
          {
            "args": (v34/*: any*/),
            "concreteType": "SearchItemConnection",
            "kind": "LinkedField",
            "name": "search",
            "plural": false,
            "selections": [
              {
                "concreteType": "SearchResultItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v35/*: any*/),
                      (v36/*: any*/),
                      (v37/*: any*/),
                      {
                        "concreteType": "SearchLinkedResult",
                        "kind": "LinkedField",
                        "name": "linkedResults",
                        "plural": true,
                        "selections": [
                          (v36/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "category"
                          },
                          (v38/*: any*/),
                          (v39/*: any*/),
                          (v40/*: any*/),
                          (v41/*: any*/),
                          (v37/*: any*/),
                          (v42/*: any*/),
                          (v43/*: any*/),
                          (v44/*: any*/),
                          (v45/*: any*/)
                        ]
                      },
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isSearchResult"
                      },
                      (v39/*: any*/),
                      (v41/*: any*/),
                      (v40/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "goal",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareLocalizationField",
                                    "kind": "LinkedField",
                                    "name": "localizedLabel",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "messageId"
                                      }
                                    ]
                                  },
                                  (v46/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "score"
                                  }
                                ]
                              },
                              {
                                "concreteType": "TownsquareTargetDate",
                                "kind": "LinkedField",
                                "name": "targetDate",
                                "plural": false,
                                "selections": (v48/*: any*/)
                              },
                              (v36/*: any*/),
                              (v49/*: any*/),
                              (v37/*: any*/)
                            ]
                          },
                          (v52/*: any*/)
                        ],
                        "type": "SearchResultAtlasGoal"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "TownsquareProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "isPrivate"
                              },
                              {
                                "concreteType": "TownsquareTargetDate",
                                "kind": "LinkedField",
                                "name": "dueDate",
                                "plural": false,
                                "selections": (v48/*: any*/)
                              },
                              {
                                "concreteType": "TownsquareProjectState",
                                "kind": "LinkedField",
                                "name": "state",
                                "plural": false,
                                "selections": [
                                  (v47/*: any*/),
                                  (v46/*: any*/)
                                ]
                              },
                              (v36/*: any*/),
                              (v49/*: any*/)
                            ]
                          },
                          (v52/*: any*/)
                        ],
                        "type": "SearchResultAtlasProject"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v42/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "entity",
                            "plural": false,
                            "selections": [
                              (v35/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "SearchFederatedEmailUser",
                                    "kind": "LinkedField",
                                    "name": "sender",
                                    "plural": false,
                                    "selections": (v54/*: any*/)
                                  }
                                ],
                                "type": "SearchFederatedEmailEntity"
                              }
                            ]
                          }
                        ],
                        "type": "SearchResultFederated"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v42/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "tier"
                          },
                          {
                            "concreteType": "CompassComponent",
                            "kind": "LinkedField",
                            "name": "component",
                            "plural": false,
                            "selections": [
                              (v37/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "state"
                              },
                              (v36/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "ownerId"
                          }
                        ],
                        "type": "SearchResultCompassComponent"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v55/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "isVerified"
                          },
                          {
                            "concreteType": "SearchConfluenceResultSpace",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                              (v36/*: any*/),
                              (v53/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "webUiLink"
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "confluenceEntity",
                            "plural": false,
                            "selections": [
                              (v35/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v43/*: any*/),
                                  {
                                    "concreteType": "ConfluenceCommentCountSummary",
                                    "kind": "LinkedField",
                                    "name": "commentCountSummary",
                                    "plural": false,
                                    "selections": [
                                      (v56/*: any*/)
                                    ]
                                  },
                                  {
                                    "concreteType": "ConfluenceLikesSummary",
                                    "kind": "LinkedField",
                                    "name": "likesSummary",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "count"
                                      }
                                    ]
                                  }
                                ],
                                "type": "ConfluencePage"
                              },
                              (v57/*: any*/)
                            ]
                          },
                          (v61/*: any*/),
                          (v52/*: any*/),
                          {
                            "condition": "includeNavBoostScore",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "navBoostScore"
                              }
                            ]
                          }
                        ],
                        "type": "SearchConfluencePageBlogAttachment"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v55/*: any*/),
                          (v52/*: any*/)
                        ],
                        "type": "SearchConfluenceSpace"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v45/*: any*/),
                          (v38/*: any*/),
                          (v44/*: any*/),
                          (v43/*: any*/),
                          (v42/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "permissionLevel"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "entity",
                            "plural": false,
                            "selections": [
                              (v35/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v53/*: any*/),
                                  (v62/*: any*/)
                                ],
                                "type": "ExternalBranch"
                              },
                              (v57/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "container",
                                    "plural": false,
                                    "selections": [
                                      (v35/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v63/*: any*/),
                                          (v40/*: any*/),
                                          (v43/*: any*/)
                                        ],
                                        "type": "ExternalSpace"
                                      },
                                      (v57/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "ExternalComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "ExternalUser",
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                      (v64/*: any*/)
                                    ]
                                  },
                                  (v62/*: any*/)
                                ],
                                "type": "ExternalCommit"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v65/*: any*/),
                                  {
                                    "concreteType": "ExternalReaction",
                                    "kind": "LinkedField",
                                    "name": "reactions",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "reactionType"
                                      },
                                      (v56/*: any*/)
                                    ]
                                  },
                                  {
                                    "condition": "includeThirdPartyId",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "thirdPartyId"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "ExternalDocumentType",
                                    "kind": "LinkedField",
                                    "name": "type",
                                    "plural": false,
                                    "selections": (v51/*: any*/)
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "name": "parent",
                                    "plural": false,
                                    "selections": [
                                      (v35/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v63/*: any*/)
                                        ],
                                        "type": "ExternalDocument"
                                      },
                                      (v57/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "ExternalDocument"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v66/*: any*/),
                                  (v70/*: any*/),
                                  (v37/*: any*/),
                                  {
                                    "concreteType": "ExternalAttachment",
                                    "kind": "LinkedField",
                                    "name": "attachments",
                                    "plural": true,
                                    "selections": [
                                      (v39/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "mimeType"
                                      },
                                      (v40/*: any*/),
                                      (v71/*: any*/),
                                      (v35/*: any*/)
                                    ]
                                  },
                                  (v73/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "container",
                                    "plural": false,
                                    "selections": [
                                      (v35/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v63/*: any*/),
                                          (v77/*: any*/),
                                          (v41/*: any*/),
                                          (v36/*: any*/),
                                          (v78/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "membershipType"
                                          }
                                        ],
                                        "type": "ExternalConversation"
                                      },
                                      (v57/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "lastActive"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "reactionCount"
                                  }
                                ],
                                "type": "ExternalMessage"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v37/*: any*/),
                                  (v63/*: any*/),
                                  (v78/*: any*/),
                                  {
                                    "concreteType": "ExternalUser",
                                    "kind": "LinkedField",
                                    "name": "members",
                                    "plural": true,
                                    "selections": [
                                      (v35/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "ExternalConversation"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v63/*: any*/),
                                  {
                                    "condition": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                      {
                                        "concreteType": "ExternalUser",
                                        "kind": "LinkedField",
                                        "name": "contributors",
                                        "plural": true,
                                        "selections": (v76/*: any*/)
                                      }
                                    ]
                                  },
                                  {
                                    "condition": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": (v81/*: any*/)
                                  },
                                  (v82/*: any*/),
                                  {
                                    "concreteType": "ExternalCustomerOrgLastActivity",
                                    "kind": "LinkedField",
                                    "name": "customerOrgLastActivity",
                                    "plural": false,
                                    "selections": (v83/*: any*/)
                                  }
                                ],
                                "type": "ExternalCustomerOrg"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "stage"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "dealClosedAt"
                                  },
                                  {
                                    "concreteType": "ExternalDealLastActivity",
                                    "kind": "LinkedField",
                                    "name": "lastActivity",
                                    "plural": false,
                                    "selections": (v83/*: any*/)
                                  },
                                  {
                                    "condition": "__relay_internal__pv__isdealownersenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": (v81/*: any*/)
                                  },
                                  (v82/*: any*/)
                                ],
                                "type": "ExternalDeal"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v84/*: any*/),
                                  (v85/*: any*/),
                                  (v86/*: any*/),
                                  (v49/*: any*/),
                                  (v87/*: any*/),
                                  (v65/*: any*/),
                                  (v88/*: any*/)
                                ],
                                "type": "ExternalProject"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v84/*: any*/),
                                  (v85/*: any*/),
                                  (v86/*: any*/),
                                  (v87/*: any*/),
                                  (v43/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "team"
                                  },
                                  (v65/*: any*/),
                                  {
                                    "concreteType": "ExternalWorkItemProject",
                                    "kind": "LinkedField",
                                    "name": "workItemProject",
                                    "plural": false,
                                    "selections": (v74/*: any*/)
                                  },
                                  (v88/*: any*/)
                                ],
                                "type": "ExternalWorkItem"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v39/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "lastUpdate"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "pullRequestId"
                                  },
                                  (v62/*: any*/)
                                ],
                                "type": "ExternalPullRequest"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "durationInSeconds"
                                  },
                                  (v71/*: any*/),
                                  {
                                    "concreteType": "ExternalChapter",
                                    "kind": "LinkedField",
                                    "name": "chapters",
                                    "plural": true,
                                    "selections": [
                                      (v39/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "startTimeInSeconds"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "ExternalUser",
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": [
                                      (v75/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": (v89/*: any*/)
                                      }
                                    ]
                                  }
                                ],
                                "type": "ExternalVideo"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v36/*: any*/),
                                  (v40/*: any*/),
                                  (v90/*: any*/),
                                  (v80/*: any*/)
                                ],
                                "type": "ExternalDashboard"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v36/*: any*/),
                                  (v40/*: any*/),
                                  {
                                    "alias": "dataTableType",
                                    "kind": "ScalarField",
                                    "name": "type"
                                  },
                                  (v90/*: any*/),
                                  (v80/*: any*/)
                                ],
                                "type": "ExternalDataTable"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v63/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "accountName"
                                  },
                                  {
                                    "concreteType": "ExternalUser",
                                    "kind": "LinkedField",
                                    "name": "contactUser",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "ThirdPartyUser",
                                        "kind": "LinkedField",
                                        "name": "thirdPartyUser",
                                        "plural": false,
                                        "selections": [
                                          (v68/*: any*/),
                                          (v36/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "type": "ExternalCustomerContact"
                              }
                            ]
                          },
                          (v91/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "entity",
                            "plural": false,
                            "selections": [
                              (v35/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v85/*: any*/),
                                  (v92/*: any*/),
                                  (v93/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "recurringEventId"
                                  },
                                  (v94/*: any*/)
                                ],
                                "type": "ExternalCalendarEvent"
                              },
                              (v57/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "ExternalThumbnail",
                                    "kind": "LinkedField",
                                    "name": "thumbnail",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "externalUrl"
                                      }
                                    ]
                                  }
                                ],
                                "type": "ExternalDesign"
                              }
                            ]
                          },
                          {
                            "concreteType": "SearchResultGraphDocument",
                            "kind": "LinkedField",
                            "name": "linkedEntities",
                            "plural": true,
                            "selections": [
                              (v36/*: any*/),
                              (v39/*: any*/),
                              (v40/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "entity",
                                "plural": false,
                                "selections": [
                                  (v35/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v93/*: any*/),
                                      (v92/*: any*/),
                                      (v94/*: any*/)
                                    ],
                                    "type": "ExternalCalendarEvent"
                                  },
                                  (v57/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v73/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "name": "container",
                                        "plural": false,
                                        "selections": [
                                          (v35/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v77/*: any*/),
                                              (v41/*: any*/)
                                            ],
                                            "type": "ExternalConversation"
                                          },
                                          (v57/*: any*/)
                                        ]
                                      },
                                      (v66/*: any*/),
                                      (v70/*: any*/),
                                      (v37/*: any*/)
                                    ],
                                    "type": "ExternalMessage"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v37/*: any*/)
                                    ],
                                    "type": "ExternalConversation"
                                  }
                                ]
                              },
                              (v95/*: any*/),
                              (v96/*: any*/),
                              (v91/*: any*/),
                              (v44/*: any*/),
                              (v97/*: any*/)
                            ]
                          },
                          (v96/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "containerName"
                          },
                          (v95/*: any*/),
                          (v97/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "linkedEntitiesType"
                          }
                        ],
                        "type": "SearchResultGraphDocument"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v42/*: any*/),
                          (v50/*: any*/),
                          {
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issue",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "issueTypeAvatarUrl"
                              },
                              (v98/*: any*/),
                              (v49/*: any*/),
                              {
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "ids",
                                    "value": [
                                      "project"
                                    ]
                                  }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v35/*: any*/),
                                          (v53/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "project",
                                                "plural": false,
                                                "selections": (v74/*: any*/)
                                              }
                                            ],
                                            "type": "JiraProjectField"
                                          },
                                          (v36/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "fieldsById(ids:[\"project\"])"
                              },
                              {
                                "condition": "includeAssigneeField",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "assigneeField",
                                    "plural": false,
                                    "selections": [
                                      (v64/*: any*/),
                                      (v36/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v36/*: any*/)
                            ]
                          }
                        ],
                        "type": "SearchResultJiraIssue"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "projectKey"
                          },
                          (v42/*: any*/),
                          (v50/*: any*/),
                          {
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v98/*: any*/),
                              (v36/*: any*/)
                            ]
                          },
                          (v61/*: any*/)
                        ],
                        "type": "SearchResultJiraProject"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v99/*: any*/),
                        "type": "SearchResultJiraPlan"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v42/*: any*/),
                          (v50/*: any*/),
                          {
                            "concreteType": "JiraBoard",
                            "kind": "LinkedField",
                            "name": "board",
                            "plural": false,
                            "selections": [
                              (v50/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "boardFrontendUrl"
                              },
                              (v36/*: any*/)
                            ]
                          }
                        ],
                        "type": "SearchResultJiraBoard"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v99/*: any*/),
                        "type": "SearchResultJiraDashboard"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v99/*: any*/),
                        "type": "SearchResultJiraFilter"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "MercuryFocusArea",
                            "kind": "LinkedField",
                            "name": "focusArea",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "MercuryFocusAreaStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  (v49/*: any*/),
                                  (v63/*: any*/),
                                  (v36/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "MercuryFocusAreaHealth",
                                "kind": "LinkedField",
                                "name": "health",
                                "plural": false,
                                "selections": [
                                  (v49/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "color"
                                  },
                                  (v63/*: any*/),
                                  (v36/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "MercuryTargetDate",
                                "kind": "LinkedField",
                                "name": "targetDate",
                                "plural": false,
                                "selections": (v100/*: any*/)
                              },
                              (v36/*: any*/),
                              (v53/*: any*/),
                              {
                                "concreteType": "MercuryFocusAreaType",
                                "kind": "LinkedField",
                                "name": "focusAreaType",
                                "plural": false,
                                "selections": (v74/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "name": "owner",
                                "plural": false,
                                "selections": (v89/*: any*/)
                              }
                            ]
                          },
                          (v42/*: any*/)
                        ],
                        "type": "SearchResultMercuryFocusArea"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v42/*: any*/),
                          {
                            "concreteType": "MercuryFocusArea",
                            "kind": "LinkedField",
                            "name": "focusArea",
                            "plural": false,
                            "selections": (v79/*: any*/)
                          }
                        ],
                        "type": "SearchResultMercuryFocusAreaStatusUpdate"
                      },
                      {
                        "condition": "includePassionfruitAsk",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "SpfAsk",
                                "kind": "LinkedField",
                                "name": "ask",
                                "plural": false,
                                "selections": [
                                  (v87/*: any*/),
                                  {
                                    "concreteType": "SpfAskTargetDate",
                                    "kind": "LinkedField",
                                    "name": "targetDate",
                                    "plural": false,
                                    "selections": (v100/*: any*/)
                                  },
                                  (v36/*: any*/)
                                ]
                              },
                              (v42/*: any*/)
                            ],
                            "type": "SearchResultSpfAsk"
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v101/*: any*/),
                        "type": "SearchResultTrelloBoard"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v101/*: any*/),
                        "type": "SearchResultTrelloCard"
                      },
                      {
                        "condition": "__relay_internal__pv__isassetsenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v42/*: any*/),
                              {
                                "concreteType": "AssetsSchema",
                                "kind": "LinkedField",
                                "name": "objectSchemaEntity",
                                "plural": false,
                                "selections": [
                                  (v102/*: any*/),
                                  (v36/*: any*/)
                                ]
                              }
                            ],
                            "type": "SearchResultAssetsObjectSchema"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v42/*: any*/),
                              (v103/*: any*/),
                              {
                                "concreteType": "AssetsObjectType",
                                "kind": "LinkedField",
                                "name": "objectTypeEntity",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "AssetsIcon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": (v104/*: any*/)
                                  },
                                  (v102/*: any*/),
                                  (v36/*: any*/)
                                ]
                              }
                            ],
                            "type": "SearchResultAssetsObjectType"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v42/*: any*/),
                              (v103/*: any*/),
                              {
                                "concreteType": "AssetsObject",
                                "kind": "LinkedField",
                                "name": "objectEntity",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "AssetsAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": (v104/*: any*/)
                                  },
                                  (v102/*: any*/),
                                  (v36/*: any*/)
                                ]
                              }
                            ],
                            "type": "SearchResultAssetsObject"
                          }
                        ]
                      },
                      {
                        "condition": "includePositions",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "RadarPosition",
                                "kind": "LinkedField",
                                "name": "position",
                                "plural": false,
                                "selections": [
                                  (v35/*: any*/),
                                  {
                                    "concreteType": "RadarWorker",
                                    "kind": "LinkedField",
                                    "name": "worker",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "preferredName"
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                          (v35/*: any*/),
                                          (v58/*: any*/),
                                          (v36/*: any*/)
                                        ]
                                      },
                                      (v36/*: any*/)
                                    ]
                                  },
                                  {
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "fieldIdIsIn",
                                        "value": [
                                          "positionId",
                                          "positionStatus",
                                          "positionJobTitle",
                                          "positionPositionTitle",
                                          "positionKey",
                                          "positionExternalPositionKey",
                                          "positionWorker",
                                          "focusArea"
                                        ]
                                      }
                                    ],
                                    "concreteType": "RadarFieldValueIdPair",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "fieldId"
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "name": "fieldValue",
                                        "plural": false,
                                        "selections": [
                                          (v35/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": "stringValue",
                                                "kind": "ScalarField",
                                                "name": "value"
                                              }
                                            ],
                                            "type": "RadarStringFieldValue"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "name": "value",
                                                "plural": false,
                                                "selections": [
                                                  (v35/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v53/*: any*/),
                                                      {
                                                        "concreteType": "MercuryFocusAreaStatus",
                                                        "kind": "LinkedField",
                                                        "name": "status",
                                                        "plural": false,
                                                        "selections": (v105/*: any*/)
                                                      },
                                                      {
                                                        "concreteType": "MercuryFocusAreaHealth",
                                                        "kind": "LinkedField",
                                                        "name": "health",
                                                        "plural": false,
                                                        "selections": (v105/*: any*/)
                                                      }
                                                    ],
                                                    "type": "MercuryFocusArea"
                                                  },
                                                  (v57/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "RadarAriFieldValue"
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": "fieldValues(fieldIdIsIn:[\"positionId\",\"positionStatus\",\"positionJobTitle\",\"positionPositionTitle\",\"positionKey\",\"positionExternalPositionKey\",\"positionWorker\",\"focusArea\"])"
                                  },
                                  (v36/*: any*/)
                                ]
                              }
                            ],
                            "type": "SearchResultTalentPosition"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "SearchQueryInfo",
                "kind": "LinkedField",
                "name": "queryInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "originalQuery"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "replacementQuery"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "suggestedQuery"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "originalQueryType"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "confidenceScore"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "shouldTriggerAutocorrectionExperience"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              },
              {
                "concreteType": "SearchError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "statusCode"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "product"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "integration"
                  }
                ]
              },
              {
                "condition": "includeAutoAppliedFilters",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "SearchFilterOutput",
                    "kind": "LinkedField",
                    "name": "autoAppliedFilters",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "SearchCommonFilterOutput",
                        "kind": "LinkedField",
                        "name": "commonFilters",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "SearchCommonRangeFilterOutput",
                            "kind": "LinkedField",
                            "name": "range",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "SearchCommonRangeFilterFieldsOutput",
                                "kind": "LinkedField",
                                "name": "lastModified",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "gt"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "lt"
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "SearchParticipantsOutput",
                            "kind": "LinkedField",
                            "name": "participants",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "SearchParticipantOutput",
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                  (v41/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "users"
                                  },
                                  (v106/*: any*/)
                                ]
                              },
                              (v106/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "args": (v34/*: any*/),
            "filters": [
              "experience",
              "enableHighlighting",
              "query",
              "sort",
              "disableQueryReplacement",
              "fanoutExperimentCohort",
              "filters",
              "analytics",
              "experimentContext"
            ],
            "handle": "connection",
            "key": "SearchResultsPagination__search",
            "kind": "LinkedHandle",
            "name": "search"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "2f184179b031fa92b41f52f28374cc1643bac2ef4db649db9fa7c97be2597cdd",
    "metadata": {},
    "name": "SearchResultsPaginationQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "includeAssets": includeAssets_provider,
      "__relay_internal__pv__isassetsenabledrelayprovider": includeAssets_provider,
      "__relay_internal__pv__iscustomerorgownersenabledrelayprovider": isCustomerOrgOwnersEnabled_provider,
      "__relay_internal__pv__isdealownersenabledrelayprovider": isDealOwnersEnabled_provider,
      "__relay_internal__pv__jsmdcenabledrelayprovider": isJsmDcEnabled_provider
    }
  }
};
})();

(node as any).hash = "59aef00e42b63d5ea421113a751705d3";

export default node;
